import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalButtonsFn = /* @__PURE__ */ createRecipe('modalButtons', {}, [])

const modalButtonsVariantMap = {}

const modalButtonsVariantKeys = Object.keys(modalButtonsVariantMap)

export const modalButtons = /* @__PURE__ */ Object.assign(memo(modalButtonsFn.recipeFn), {
  __recipe__: true,
  __name__: 'modalButtons',
  __getCompoundVariantCss__: modalButtonsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: modalButtonsVariantKeys,
  variantMap: modalButtonsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalButtonsVariantKeys)
  },
  getVariantProps: modalButtonsFn.getVariantProps,
})